import { render, staticRenderFns } from "./servicesProduct4.vue?vue&type=template&id=33f782d2&scoped=true"
import script from "./servicesProduct4.vue?vue&type=script&lang=js"
export * from "./servicesProduct4.vue?vue&type=script&lang=js"
import style0 from "./servicesProduct4.vue?vue&type=style&index=0&id=33f782d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f782d2",
  null
  
)

export default component.exports